import { IReward } from './IReward';
import { Reward } from './Reward';

export class EstatementFeeReductionReward extends Reward {
	public static readonly CLASS: string = 'com.bancvue.rcx.config.product.rewards.api.EstatementFeeReductionReward';

	public static readonly NAME: string = 'EStatement Only Fee Reduction';

	feeReductionAmount: number = 0;

	constructor(reward?: IReward) {
	  super(EstatementFeeReductionReward.CLASS, reward ? reward.id : null);

	  if (reward) {
	    this.feeReductionAmount = (reward as any).feeReductionAmount;
	  }
	}

	getDescription(): string {
	  return `$${this.feeReductionAmount} fee reduction if Estatement qualifier met.`;
	}

	clone(): IReward {
	  const clone = new EstatementFeeReductionReward();
	  Object.assign(clone, this);
	  return clone;
	}
}

export default EstatementFeeReductionReward;
